// extracted by mini-css-extract-plugin
export default {"friendList":"FriendList_friendList__8YJ5i","item":"FriendList_item__2L4ns","avatar":"FriendList_avatar__XIeZ-","name":"FriendList_name__vF+m2","status":"FriendList_status__eIpzJ"};